import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],
    message: null,
    error: null,
    createStatus: null,
    updateStatus: null,
    deleteStatus: null,
}

const autoConfigSlice = createSlice({
    name: 'autoconfig',
    initialState,
    reducers: {
        getAutoConfigStart: (state) => {
            state.data = [];
            state.error = null;
        },
        getAutoConfigSuccess: (state, action) => {
            state.data = action?.payload?.AutoGenNumber || [];
        },
        getAutoConfigFailure: (state, action) => {
            state.error = action?.payload;
        },
        createAutoConfigStart: (state, action) => {
            state.createStatus = null;
        },
        createAutoConfigSuccess: (state, action) => {
            state.createStatus = action?.payload?.success;
        },
        createAutoConfigFailure: (state, action) => {
            state.createStatus = action?.payload?.success;
        },
        updateAutoConfigStart: (state, action) => {
            state.updateStatus = null;
        },
        updateAutoConfigSuccess: (state, action) => {
            state.updateStatus = action?.payload?.success;
        },
        updateAutoConfigFailure: (state, action) => {
            state.updateStatus = action?.payload?.success;
        },
        deleteAutoConfigStart: (state, action) => {
            state.deleteStatus = null;
        },
        deleteAutoConfigSuccess: (state, action) => {
            state.deleteStatus = action?.payload?.success;
        },
        deleteAutoConfigFailure: (state, action) => {
            state.deleteStatus = action?.payload?.success;
        },
        resetState: (state) => {
            state.data = [];
            state.message = null;
            state.error = null;
            state.createStatus = null;
            state.updateStatus = null;
            state.deleteStatus = null;
        }
    }
});
export const {
    getAutoConfigStart,
    getAutoConfigSuccess,
    getAutoConfigFailure,
    createAutoConfigStart,
    createAutoConfigSuccess,
    createAutoConfigFailure,
    updateAutoConfigStart,
    updateAutoConfigSuccess,
    updateAutoConfigFailure,
    deleteAutoConfigStart,
    deleteAutoConfigSuccess,
    deleteAutoConfigFailure
} = autoConfigSlice?.actions;

export default autoConfigSlice?.reducer;